import styled, { css } from "styled-components";
import Icon from "components/Icon";

export const Wrapper = styled.div`
  margin-bottom: 20px;

  .StripeElement {
    width: 100%;
    margin-left: 10px;
  }
`;

export const Field = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ccc;
  width: 100%;
  padding: 10px 0;
  margin-bottom: 10px;

  ${(props) =>
    props.width &&
    css`
      max-width: ${props.width}px;
    `}
`;

export const InputField = styled.input`
  font-family: "Exo", sans-serif;
  width: 100%;
  padding: 0;
  font-size: 14px;
  margin-left: 10px;
  border: none;
  outline: none;
`;

export const FieldIcon = styled(Icon)`
  width: 20px;
  height: 20px;
`;

export const Error = styled.div`
  font-size: 13px;
  color: red;
  text-align: right;
`;
